import { render, staticRenderFns } from "./AddCommandPanel.vue?vue&type=template&id=586e2d32&scoped=true"
import script from "./AddCommandPanel.vue?vue&type=script&lang=js"
export * from "./AddCommandPanel.vue?vue&type=script&lang=js"
import style0 from "./AddCommandPanel.vue?vue&type=style&index=0&id=586e2d32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586e2d32",
  null
  
)

export default component.exports